export { default as LegacyNavAdoptions } from './LegacyNavAdoptions';
